import rivets from 'rivets';
import 'rivets-backbone-adapter';

rivets.configure({
  prefix: 'data-bind'
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/rivets/config.js
 **/